<template>
    <v-row>
        <v-col cols="12">
            <v-btn
                class="mx-2"
                fab
                dark
                color="blue"
                @click="openModalCreate({})"
            >
                <v-icon dark> mdi-plus </v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12">
            <v-data-table
                dense
                :headers="headers"
                :items="incidencias"
                :page="filtros.page"
                :items-per-page="filtros.amount"
                item-key="id"
                class="elevation-1"
                :sort-by="['nombre']"
                :sort-desc="[false]"
                @update:items-per-page="ChangeSize"
                @pagination="ChangePage"
            >
                <template v-slot:item.url_file="{ item }">
                    <a
                        :href="item.url_file"
                        target="__blank"
                        v-if="item.nombre_archivo"
                    >
                        <v-icon
                            small
                            class="mr-2"
                            color="#1d2735"
                            style="font-size: 25px"
                            title="Archivo"
                            >mdi-file</v-icon
                        >
                    </a>
                </template>
                <template v-slot:item.fecha_inicio="{ item }">
                    {{ item.fecha_inicio | format_date }}
                </template>
                <template v-slot:item.fecha_fin="{ item }">
                    <template v-if="item.fecha_fin">
                        {{ item.fecha_fin | format_date }}
                    </template>
                </template>
                <template v-slot:item.justificado="{ item }">
                    {{ item.justificado ? "Si" : "No" }}
                </template>
                <template v-slot:item.action="{ item }">
                    <v-icon
                        @click="openModalCreate(item)"
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >

                    <v-icon
                        @click="openModal(item)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </template>
            </v-data-table>
        </v-col>

        <!-- Dialog para eliminar una incidencia -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteIncidencia()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog para crear una incidencia -->
        <v-dialog v-model="dialog_create" max-width="1024px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar incidencia
                </v-card-title>
                <v-card-text style="text-align: center">
                    <form ref="incidencia_form">
                        <v-row>
                            <v-col cols="12" md="6">
                                <date-select
                                    name="fecha_inicio"
                                    label="Fecha"
                                    v-model="selectedItem.fecha_inicio"
                                >
                                </date-select>
                            </v-col>
                            <template v-if="tipo_incidencia">
                                <v-col
                                    cols="12"
                                    md="6"
                                    v-if="tipo_incidencia.baja"
                                >
                                    <date-select
                                        name="fecha_fin"
                                        label="Fecha de fin"
                                        v-model="selectedItem.fecha_fin"
                                    >
                                    </date-select>
                                </v-col>
                                <v-col cols="12" md="6" v-else>
                                    <v-text-field
                                        label="Duración"
                                        name="duracion"
                                        v-model="selectedItem.duracion"
                                        v-mask="'##:##'"
                                    >
                                    </v-text-field>
                                </v-col>
                            </template>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    name="id_tipo"
                                    v-model="selectedItem.id_tipo"
                                    label="Denominación"
                                    item-text="nombre"
                                    item-value="id"
                                    :items="tipos_incidencias"
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6"
                                ><v-checkbox
                                    label="Justificado"
                                    v-model="selectedItem.justificado"
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-file-input
                                    name="archivo"
                                    label="Justificación"
                                    ref="fileInput"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </form>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="saveincidencia()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
export default {
    props: ["usuario"],
    data() {
        return {
            dialog: false,
            dialog_create: false,
            selectedItem: {},
            incidencias: [],
            tipos_incidencias: [],
            totales: 0,
            filtros: {
                page: 1,
                amount: 15,
            },
            headers: [
                { text: "Fecha de inicio", value: "fecha_inicio" },
                { text: "Fecha de fin", value: "fecha_fin" },
                { text: "Duración", value: "duracion" },
                { text: "Tipo de incidencia", value: "tipo.nombre" },
                { text: "Justificado", value: "justificado" },
                { text: "Archivo", value: "url_file" },
                { text: "Acciones", value: "action" },
            ],
        };
    },
    created() {
        this.getIncidencias();
        this.getTipoIncidencia();
    },
    methods: {
        prFileToBase64(file) {
            return new Promise((resolve, reject) => {
                this.fileToBase64(file, (base64string) => {
                    resolve(base64string);
                });
            });
        },
        fileToBase64(file, callback) {
            const reader = new FileReader();
            reader.onload = function (event) {
                const base64String = event.target.result.split(",")[1];
                callback(base64String);
            };

            reader.readAsDataURL(file);
        },
        ChangeSize(event) {
            this.filtros.amount = event;
            this.getClientes();
            //console.log(`evento: ${event}`);
        },
        ChangePage(event) {
            this.filtros.page = event.page;
            this.getClientes();
            //console.log(event);
        },
        async getTipoIncidencia() {
            try {
                const resp = await axios.get(`api/empleado/incidencia/tipos`);
                this.tipos_incidencias = resp.data;
            } catch (ex) {}
        },
        async saveincidencia() {
            const formData = new FormData(this.$refs.incidencia_form);
            formData.append("justificado", this.selectedItem.justificado);
            console.log(formData.get("archivo"));
            try {
                let resp = null;
                if (this.selectedItem.id != null) {
                    resp = await axios.post(
                        `api/empleado/incidencia/${this.selectedItem.id}`,
                        formData
                    );
                } else {
                    resp = await axios.post(
                        `api/empleado/${this.usuario.id}/incidencia`,
                        formData
                    );
                }
                this.getIncidencias();
                this.dialog_create = false;
            } catch (ex) {}
        },
        openModal(item) {
            this.dialog = true;
            this.selectedItem = item;
        },
        openModalCreate(item) {
            this.dialog_create = true;
            this.selectedItem = item;
        },
        async getIncidencias() {
            if (this.usuario != null) {
                try {
                    const resp = await axios.get(
                        `api/empleado/${this.usuario.id}/incidencia${this.filter_string}`
                    );
                    this.totales = resp.data.total;
                    this.incidencias = resp.data.data;
                } catch (ex) {}
            }
        },
        async deleteIncidencia() {
            if (this.usuario != null) {
                try {
                    const resp = await axios.delete(
                        `api/empleado/incidencia/${this.selectedItem.id}`
                    );
                    this.getIncidencias();
                    this.dialog = false;
                } catch (ex) {
                    this.dialog = false;
                }
            }
        },
    },
    watch: {},
    computed: {
        tipo_incidencia() {
            const ele = this.tipos_incidencias.find(
                (ele) => ele.id == this.selectedItem.id_tipo
            );
            console.log("ele", ele);
            return ele ?? {};
        },
        filter_string() {
            let result = `?page=${this.filtros.page}&amount=${this.filtros.amount}`;
            return result;
        },
    },
};
</script>
